import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  username: null,
  password: null,
};

export const loginDataSlice = createSlice({
  name: "loginData",
  initialState,
  reducers: {
    setData: (state, actions) => {
      const { username, password } = actions.payload;
      state.username = username;
      state.password = password;
    },
    resetData: () => initialState,
  },
});

export const { setData, resetData } = loginDataSlice.actions;

export default loginDataSlice.reducer;
